import { authStorage } from "./authStorage";

export const SESSION_EXPIRED_EVENT = "pos-session-expired";

let sessionPromptActive = false;

export const isLoginRoute = (path = "") => (
    path === "/login"
    || path === "/admin/login"
    || path === "/superadmin/login"
    || path === "/pos/login"
    || path.endsWith("/login")
);

export const resolveSessionLoginPath = (path = window.location.pathname) => {
    const loginContext = authStorage.getLoginContext();
    const user = authStorage.getUser();
    const userType = Number(user?.user_type);

    if (loginContext === "superadmin" || path.startsWith("/superadmin") || userType === 0) {
        return "/superadmin/login";
    }

    if (loginContext === "admin" || path.startsWith("/admin") || userType === 1) {
        return "/admin/login";
    }

    return "/login";
};

export const resetSessionExpiredPrompt = () => {
    sessionPromptActive = false;
};

export const emitSessionExpired = (error) => {
    if (sessionPromptActive || typeof window === "undefined") return;

    const path = window.location.pathname;
    if (isLoginRoute(path)) return;

    sessionPromptActive = true;

    const status = error?.response?.status;
    const serverMessage = String(error?.response?.data?.message || "").trim();
    const loginPath = resolveSessionLoginPath(path);

    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, {
        detail: {
            loginPath,
            status,
            serverMessage,
            message: status === 401
                ? "Your sign-in session has expired after the allowed time. Please sign in again to continue working securely."
                : "Your session can no longer be verified. Please sign in again to continue working securely.",
        },
    }));
};
